export const SETUP_THREATMETRIX = 'page/SETUP_THREATMETRIX';
